// bao migrate skip
import "./../bindings/bao-date-time-box";
import "./../bindings/bao-date-time-picker";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import * as moment from "moment";
import BaoDialog from "./../factories/bao-dialog";
class ShiftScheduleSwapEmployees {
    IsLoading: KnockoutObservable<boolean>;
    PersonAId: KnockoutObservable<string>;
    PersonBId: KnockoutObservable<string>;
    ValidDate: KnockoutObservable<string>;
    PersonAName: KnockoutObservable<string>;
    PersonBName: KnockoutObservable<string>;
    baoSearcherPersonA: Bindings.baoSearcher;
    baoSearcherPersonB: Bindings.baoSearcher;
    datetimepickerValidDate: Bindings.baoDateTimePicker;
    datetimeboxValidDate: Bindings.baoDateTimeBox;
    /**
     *
     * @param personAId if is set, Binding for PersonA will be initialized
     * @param personBId if is set, Binding for PersonB will be initialized
     * @param validDate if is set, its bindings will be initialized
     */
    constructor(personAId?, personBId?, validDate?, personAName?, personBName?) {
        //if (personAId) {
        this.PersonAId = ko.observable(personAId);
        this.baoSearcherPersonA = {
            ObjectId: this.PersonAId,
            ObjectValue: 'FullName',
            SearchType: "Person"
        };
        if (!(personAId)) {
            this.baoSearcherPersonA.AutoComplete = true;
        }
        //}
        //if (personBId) {
        this.PersonBId = ko.observable(personBId);
        this.baoSearcherPersonB = {
            ObjectId: this.PersonBId,
            ObjectValue: 'FullName',
            SearchType: "Person",
            AutoComplete: true
        };
        //}
        //if (validDate) {
        this.ValidDate = ko.observable(validDate);
        this.datetimeboxValidDate = {
            value: this.ValidDate,
            culture: "de-DE"
        };
        this.datetimepickerValidDate = {};
        //}
        this.PersonAName = ko.observable(personAName);
        this.PersonBName = ko.observable(personBName);
    }
    WizzardPersonB() {
        if (!this.PersonAId() || !this.ValidDate()) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgShiftScheduleSwapWizzardValidation"), "info");
            return;
        }
        this.IsLoading(true);
        return Bao.post("ShiftScheduleSwapEmployees/PersonBWizzard", JSON.stringify({
            personAId: this.PersonAId(),
            validDate: this.ValidDate()
        }))
            .then((serverResult: {
            Success: boolean;
            PersonBId: string;
            PersonBName: string;
            ErrorMessage: string;
        }) => {
            if (serverResult.Success) {
                this.PersonBId(serverResult.PersonBId);
                this.PersonBName(serverResult.PersonBName);
            }
            else {
                new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgNothingFound"), "info");
            }
            this.IsLoading(false);
        });
    }
    /**
     * Check if the input mask is correct filled
     * @param vm
     * @returns JQueryPromise<void> resolved if everything is fine; rejected if the form isn't filled correct
     */
    CheckInput(): JQueryPromise<void> {
        if (!this.PersonAId() || !this.PersonBId() || !this.ValidDate()) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
            return $.Deferred<void>().reject().promise();
        }
        return $.Deferred<void>().resolve().promise();
    }
    SwapShiftPlans(): JQueryPromise<any> {
        return Bao.post("ShiftScheduleSwapEmployees/SwapShiftPlans", JSON.stringify({
            personAId: this.PersonAId(),
            personBId: this.PersonBId(),
            validDate: this.ValidDate()
        }))
            .then((serverResult: {
            Success: boolean;
            ErrorMessage: string;
        }) => {
            if (serverResult.Success) {
            }
            else {
                new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgNothingFound"), "info");
            }
        });
    }
}
export default ShiftScheduleSwapEmployees;